import React from "react";
import { Container, Box, Typography, Paper, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useLocation, useNavigate } from "react-router-dom";

const SystemError = ({ title, errorMessage }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const errorTitle = location.state?.title || title || "System Error";
  const message = location.state?.errorMessage || errorMessage || "An unexpected error occurred. Please contact support.";

  return (
    <Container maxWidth="sm">
      <Paper elevation={6} sx={{ mt: 10, p: 5, textAlign: "center", borderRadius: 4 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h5" color="error" gutterBottom>
            {errorTitle}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {message}
          </Typography>
          <Button variant="contained" color="primary" onClick={() => navigate("/login")}>
            Back to Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SystemError;
